import Vue from 'vue';
import App from './App.vue';
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin.js";
import { SplitText } from "gsap/SplitText.js";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
//import { GSDevTools } from "gsap/GSDevTools.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import 'what-input'

gsap.registerPlugin(SplitText, MotionPathPlugin, DrawSVGPlugin, ScrollTrigger, ScrollToPlugin);
window.history.scrollRestoration = "manual"
//GSDevTools.create();
Vue.config.productionTip = false

Vue.mixin({
  methods: {
    toKebab(string) {
      return string.replace(/([a-z])([A-Z])/g, "$1-$2")
            .replace(/[\s_]+/g, '-')
            .toLowerCase(); 
    },
    isMobile() {
      if (!window.innerWidth) return false
      return (window.innerWidth <  800)
    },
    isOverlapping(div1, div2) {
      let rect1 = div1.getBoundingClientRect();
      let rect2 = div2.getBoundingClientRect();
      return !(
              rect1.right < rect2.left ||
              rect1.left > rect2.right ||
              rect1.bottom < rect2.top ||
              rect1.top > rect2.bottom
          )
    },
    SVGBoundingClientRect(elem, svg) {
      if(!svg) svg = document.querySelector("svg.logo");
      let elemBBox = elem.getBoundingClientRect();
      let corners = {
        topLeft: this.convertToSVGPoint(elemBBox.x, elemBBox.y, svg),
        topRight: this.convertToSVGPoint(elemBBox.x + elemBBox.width, elemBBox.y, svg),
        bottomLeft: this.convertToSVGPoint(elemBBox.x, elemBBox.y + elemBBox.height, svg),
        bottomRight: this.convertToSVGPoint(elemBBox.x + elemBBox.width, elemBBox.y + elemBBox.height, svg)
      }
      return {
        x: corners.topLeft.x,
        y: corners.topLeft.y,
        top: corners.topLeft.y,
        bottom: corners.bottomLeft.y,
        left: corners.topLeft.x,
        right: corners.topRight.x,
        width: corners.topRight.x - corners.topLeft.x,
        height:  corners.bottomLeft.y - corners.topLeft.y
      }
    },
    convertToSVGPoint(x, y, svg) {
      if(!svg) svg = document.querySelector("svg.logo");
      let pt = DOMPoint.fromPoint({ x: x, y: y});
      let transformedPt = pt.matrixTransform( svg.getScreenCTM().inverse() );
      return {x: transformedPt.x,
              y: transformedPt.y}
    },
  }
})

new Vue({
  render: h => h(App),
}).$mount('#app')
